import React from 'react'

function TvNotFound() {
    return (
        <div className="w-full h-full flex flex-col items-center justify-center text-center p-4 bg-white">
            <svg
                className="w-16 h-16 text-yellow-500 mb-4"
                fill="currentColor"
                viewBox="0 0 20 20"
            >
                <path
                    fillRule="evenodd"
                    d="M8.257 3.099c.765-1.36 2.72-1.36 3.485 0l6.518 11.593c.75 1.334-.213 2.991-1.742 2.991H3.48c-1.53 0-2.492-1.657-1.742-2.99L8.257 3.1zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-1-2a1 1 0 01-1-1V8a1 1 0 112 0v2a1 1 0 01-1 1z"
                    clipRule="evenodd"
                />
            </svg>
            <p className="text-gray-700 whitespace-pre-line">
                Sorry for the inconvenience,{"\n"}Feed is not available at this time.
            </p>
        </div>
    );
}

export default TvNotFound